var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmountPayable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 1.5H4.49988C3.67488 1.5 3.00738 2.175 3.00738 3L2.99988 15C2.99988 15.825 3.66738 16.5 4.49238 16.5H13.4999C14.3249 16.5 14.9999 15.825 14.9999 15V6L10.4999 1.5ZM11.2499 9H8.24988V9.75H10.4999C10.9124 9.75 11.2499 10.0875 11.2499 10.5V12.75C11.2499 13.1625 10.9124 13.5 10.4999 13.5H9.74988V14.25H8.24988V13.5H6.74988V12H9.74988V11.25H7.49988C7.08738 11.25 6.74988 10.9125 6.74988 10.5V8.25C6.74988 7.8375 7.08738 7.5 7.49988 7.5H8.24988V6.75H9.74988V7.5H11.2499V9ZM9.74988 6V2.625L13.1249 6H9.74988Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmountPayable);
export default __webpack_public_path__ + "static/media/AmountPayable.18399f1517b023c7019e8035de9a186e.svg";
export { ForwardRef as ReactComponent };